module.exports = __webpack_public_path__ + "img/SIS_LOGO_SHADOWED.7018c5d7.png";